// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"rppFHQ6XruURBunHYxR_f","settingsTitle":"_3V--MxehelOMzno7JUyATE","settingsDescription":"_2ukFmL6V10JhA52i8GAHrn","labelText":"uzI5ThkuSSyCDU4qheHun"};